import * as actions from './actions'

export { actions }

export const createState = () => ({
  geolocation: {
    supported: false,
    requestFail: false,
    requestSuccess: false,
    longitude: null,
    latitude: null,
  }
})
